var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8091,
    y1: 420.503,
    x2: 254.8091,
    y2: -178.647,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9EB644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046,
    style: {
      stopColor: "#9CB441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#738611"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M470.79,42.968c0-15.752-12.769-28.519-28.519-28.519H69.729 c-15.751,0-28.519,12.769-28.519,28.519v220.607l0,0v222.484c0,14.327,12.769,25.942,28.519,25.942l0,0h257.494h59.911h55.137 c15.751,0,28.519-11.614,28.519-25.942V375.901v-0.002V42.968H470.79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 518.2884,
    y1: -11.4872,
    x2: 92.9684,
    y2: 413.8427,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#738611",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#738611"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M441.33,52.261c-4.63-5.975-11.87-9.826-20.015-9.826H256H90.684l0,0 c-12.54,0-25.311,11.332-25.311,25.311v195.789l0,0v197.454c0,5.786,2.351,11.068,6.224,15.112L107.497,512h219.726h59.911h55.137 c15.751,0,28.519-11.614,28.519-25.942V375.901v-0.002V81.721L441.33,52.261z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.3606,
    y1: 132.795,
    x2: 450.8406,
    y2: 56.315,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#97AAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M446.627,458.702V67.747c0-13.972-11.339-25.311-25.311-25.311H90.684 c-13.972,0-25.311,11.339-25.311,25.311v390.955c0,13.972,11.339,25.311,25.311,25.311h330.632 C435.287,484.013,446.627,472.673,446.627,458.702z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8086,
    y1: 327.353,
    x2: 254.8086,
    y2: -241.457,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E6E6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M319.21,484.013H90.684c-13.979,0-25.311-11.332-25.311-25.311V67.747 c0-13.979,11.332-25.311,25.311-25.311h330.632c13.979,0,25.311,11.332,25.311,25.311v295.478c0,3.873-1.524,7.591-4.243,10.35 l-98.736,100.209C337.201,480.328,328.398,484.013,319.21,484.013z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.7358,
    y1: 318.4212,
    x2: 458.9258,
    y2: 463.9012,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FC7E2",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4975AD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M256,484.013H88.08c-12.54,0-22.707-11.332-22.707-25.311v-48.934V67.747 c0-13.979,10.166-25.311,22.707-25.311H256V484.013z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.2354,
    y1: 137.0685,
    x2: -35.2147,
    y2: 337.6284,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FC7E2",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4975AD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M446.627,263.534v197.454c0,12.716-11.332,23.024-25.311,23.024h-48.934H90.684 c-13.979,0-25.311-10.308-25.311-23.024V263.534C65.373,262.136,446.627,263.534,446.627,263.534z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.9359,
    y1: 134.8063,
    x2: 384.6201,
    y2: 85.122,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M445.331,369.269c0,0-0.748,2.118-3.692,5.063c-1.093,1.093-97.409,98.863-97.409,98.863 c-6.819,6.921-16.129,10.818-25.845,10.818l0,0l0,0c8.388,0,15.186-6.8,15.186-15.186v-74.246c0-13.979,11.332-25.311,25.311-25.311 L445.331,369.269L445.331,369.269z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 306.2639,
    y1: 398.3541,
    x2: 276.3938,
    y2: 543.834,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FC7E2",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4975AD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M446.627,125.098l-82.663-82.663H157.152v5.834c0,11.084,4.953,21.035,12.751,27.766 l276.724,276.724L446.627,125.098L446.627,125.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5B0B8"
    },
    d: "M318.151,84.965H193.849c-20.235,0-36.697-16.462-36.697-36.697v-27.72h197.695v27.72 C354.848,68.503,338.386,84.965,318.151,84.965z M173.812,37.206v11.061c0,11.049,8.989,20.037,20.037,20.037h124.302 c11.048,0,20.037-8.988,20.037-20.037V37.206H173.812z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8081,
    y1: 504.586,
    x2: 254.8081,
    y2: 455.896,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#FFBF5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M347.459,52.201H164.541c-9.908,0-17.94-8.031-17.94-17.939V17.939 c0-9.908,8.032-17.939,17.94-17.939h182.919c9.908,0,17.939,8.031,17.939,17.939v16.322 C365.399,44.169,357.367,52.201,347.459,52.201z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.4456,
    y1: 334.196,
    x2: 226.1126,
    y2: 334.196,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7ECCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FA9F5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M170.136,238.111c-31.461,0-57.057-25.596-57.057-57.057s25.596-57.057,57.057-57.057 s57.056,25.596,57.056,57.057S201.596,238.111,170.136,238.111z M170.136,144.076c-20.391,0-36.978,16.588-36.978,36.978 s16.588,36.978,36.978,36.978c20.39,0,36.977-16.588,36.977-36.978S190.525,144.076,170.136,144.076z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.9138,
    y1: 125.3835,
    x2: 322.3933,
    y2: 125.3835,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7BAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E24786"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    d: "M283.094,390.685l37.816-37.816c3.92-3.92,3.92-10.277,0-14.198 c-3.921-3.919-10.276-3.919-14.198,0l-37.816,37.816l-37.816-37.816c-3.92-3.919-10.277-3.919-14.198,0 c-3.92,3.92-3.92,10.277,0,14.198l37.816,37.816l-37.816,37.816c-3.92,3.92-3.92,10.277,0,14.198c1.961,1.96,4.53,2.94,7.099,2.94 s5.139-0.981,7.099-2.94l37.816-37.816l37.816,37.816c1.961,1.96,4.53,2.94,7.099,2.94s5.138-0.981,7.099-2.94 c3.92-3.92,3.92-10.277,0-14.198L283.094,390.685z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#697786"
    },
    d: "M326.815,222.356c1.781,3.452,3.407,7.032,4.832,10.639c0.546,1.381,1.868,2.224,3.269,2.224 c0.43,0,0.866-0.079,1.29-0.247c1.805-0.713,2.69-2.755,1.977-4.559c-1.511-3.824-3.235-7.618-5.123-11.277 c-0.889-1.726-3.011-2.403-4.733-1.512C326.602,218.512,325.924,220.632,326.815,222.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#697786"
    },
    d: "M247.121,153.908c-4.022-0.823-8.141-1.456-12.243-1.879c-1.925-0.206-3.657,1.203-3.856,3.134 c-0.2,1.931,1.204,3.657,3.134,3.856c3.872,0.4,7.759,0.996,11.555,1.774c0.238,0.049,0.475,0.072,0.709,0.072 c1.634,0,3.098-1.146,3.438-2.81C250.249,156.154,249.023,154.297,247.121,153.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#697786"
    },
    d: "M335.395,244.066c1.059,3.729,1.944,7.561,2.627,11.39c0.304,1.701,1.785,2.896,3.454,2.896 c0.205,0,0.413-0.019,0.622-0.056c1.909-0.341,3.181-2.166,2.84-4.078c-0.726-4.058-1.663-8.12-2.784-12.072 c-0.53-1.866-2.474-2.952-4.34-2.42C335.949,240.257,334.866,242.2,335.395,244.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#697786"
    },
    d: "M339.505,267.052c0.239,3.072,0.36,6.198,0.36,9.292c0,0.802-0.008,1.602-0.023,2.4 c-0.039,1.941,1.501,3.545,3.441,3.584c0.024,0.001,0.049,0.001,0.072,0.001c1.907,0,3.474-1.527,3.512-3.442 c0.018-0.847,0.025-1.695,0.025-2.543c0-3.277-0.129-6.587-0.383-9.839c-0.151-1.936-1.843-3.382-3.777-3.23 C340.8,263.426,339.354,265.117,339.505,267.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#697786"
    },
    d: "M342.94,287.341c-1.924-0.23-3.674,1.148-3.904,3.075c-0.459,3.861-1.117,7.741-1.955,11.53 c-0.42,1.895,0.776,3.771,2.671,4.189c0.256,0.057,0.511,0.084,0.762,0.084c1.612,0,3.066-1.116,3.427-2.756 c0.888-4.016,1.585-8.127,2.072-12.219C346.244,289.318,344.867,287.57,342.94,287.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#697786"
    },
    d: "M302.324,180.664c-1.488-1.252-3.702-1.059-4.951,0.426c-1.25,1.485-1.059,3.702,0.426,4.951 c2.976,2.504,5.858,5.182,8.567,7.961c0.689,0.706,1.602,1.061,2.516,1.061c0.884,0,1.77-0.332,2.453-0.998 c1.389-1.355,1.418-3.579,0.063-4.968C308.527,186.152,305.474,183.315,302.324,180.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#697786"
    },
    d: "M323.899,213.848c0.656,0,1.318-0.183,1.909-0.565c1.627-1.057,2.091-3.233,1.035-4.861 c-2.239-3.451-4.677-6.831-7.246-10.045c-1.212-1.515-3.422-1.763-4.939-0.551c-1.516,1.212-1.762,3.423-0.551,4.939 c2.425,3.034,4.727,6.224,6.84,9.482C321.621,213.284,322.749,213.848,323.899,213.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#697786"
    },
    d: "M292.463,173.165c-3.396-2.325-6.948-4.509-10.557-6.487c-1.702-0.932-3.837-0.311-4.771,1.392 c-0.933,1.702-0.309,3.837,1.392,4.771c3.407,1.867,6.758,3.927,9.963,6.123c0.607,0.416,1.299,0.614,1.984,0.614 c1.119,0,2.221-0.534,2.902-1.527C294.472,176.45,294.064,174.263,292.463,173.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#697786"
    },
    d: "M270.756,161.27c-3.79-1.611-7.705-3.049-11.633-4.273c-1.856-0.575-3.824,0.457-4.4,2.31 c-0.577,1.853,0.458,3.823,2.311,4.4c3.706,1.154,7.398,2.51,10.974,4.03c0.448,0.191,0.915,0.281,1.372,0.281 c1.367,0,2.666-0.803,3.236-2.14C273.375,164.092,272.543,162.029,270.756,161.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#697786"
    },
    d: "M356.987,321.63c-0.655-1.826-2.665-2.776-4.495-2.119l-15.46,5.55 c1.338-3.159,2.561-6.391,3.631-9.644c0.606-1.844-0.398-3.829-2.24-4.436c-1.844-0.605-3.83,0.398-4.436,2.24 c-1.018,3.096-2.184,6.172-3.459,9.178l-4.749-11.689c-0.73-1.798-2.778-2.665-4.578-1.933c-1.798,0.731-2.662,2.78-1.933,4.578 l7.789,19.173c0.552,1.359,1.863,2.193,3.255,2.193c0.396,0,0.795-0.066,1.188-0.208l23.366-8.387 C356.694,325.469,357.643,323.457,356.987,321.63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlan);
export default __webpack_public_path__ + "static/media/icon-plan.17a6281a69d00ea36556dde750705a74.svg";
export { ForwardRef as ReactComponent };